module.exports = __webpack_public_path__ + "img/bg3.9d8e9ade.png";